<div class="modal active layerSettings">
  <div class="modal__container modal__container--lg">
    <div class="fields">
      <h2>Layer Settings</h2>
      <div class="close" (click)="cancelConfiguration()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container">
        <form autocomplete="off"  name="ngLayersForm" #ngForm="ngForm" id="layersForm" class="active">
            <div class="fields__block__section">
              <div class="table-fields">
                <div>
                  <label>Layers Table</label>
                    <table>
                      <caption>
                      </caption>
                      <thead>
                        <tr>
                          <th scope="col">Name</th>
                          <th scope="col">URL</th>
                          <th scope="col">Type</th>
                          <th scope="col">Active</th>
                          <th scope="col">Default</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr mdbTableCol *ngFor="let el of configurationController.currentConfiguration.layers; let i = index"
                          (click)="selectLayer(i);"
                          [class.highlighted]="el.isselected"
                          [class.deleted]="el.istodelete"
                        >
                          <td>{{ el.name }}</td>
                          <td>{{ el.path }}</td>
                          <td>{{ el.type }}</td>
                          <td>{{ el.enabled }}</td>
                          <td>{{ el.defaultLayer }}</td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="btn">
                      <a (click)="addLayer()">Add Layer</a>
                      <a *ngIf="selectedLayerEditable()" (click)="editLayer()">Edit Layer</a>
                      <a *ngIf="selectedLayerEditable()" (click)="deleteLayer()">Delete Layer</a>
                  </div>
                </div>
              </div>
            </div>
          <div class="fields__btn">
            <button type="submit" [ngClass]="ngForm.form.valid ? 'blue' : 'gray'" (click)="saveConfiguration()" [disabled]="!ngForm.form.valid">
              Save
            </button>
            <button class="gray" (click)="cancelConfiguration()">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
